import replaceCustomShortCodes from '../../../../utils/replaceCustomShortCodes'
import {
  isFacetPageType,
  isLocationPageType
} from '@/domain/useCases/pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

interface GenerateCustomHeroCopyParams {
  term: string
  customHeroCopy?: string
  count?: number
  location?: string
  pageType: PageType
}

const generateCustomHeroCopy = ({
  term,
  customHeroCopy = '',
  count = 0,
  location = '',
  pageType
}: GenerateCustomHeroCopyParams): string => {
  let heroLocationName = ''

  if (isFacetPageType(pageType)) {
    heroLocationName = count > 0 ? ` in ${location}` : ` near ${location}`
  }

  if (isLocationPageType(pageType)) {
    heroLocationName = location
  }

  let countValue

  if (count === 0) {
    countValue = ''
  }

  if (count < 7 && count !== 0) {
    countValue = ' several'
  }

  if (count >= 7) {
    countValue = ' ' + count
  }

  return replaceCustomShortCodes({
    originalString: customHeroCopy,
    count: countValue,
    year: new Date().getFullYear(),
    secondaryTerm: term,
    condition: term.toLowerCase() || '',
    location: heroLocationName || ''
  })
}

export default generateCustomHeroCopy
